<template>
  <div class="peizhi">
    <div class="right" style="text-align: right;">
      <div style="width: 300px;display: inline-block;">
        <el-input placeholder="请输入设备编码" prefix-icon="el-icon-search" v-model="search" clearable>
        </el-input>
      </div>
        <el-button type="primary" class="search" @click="searchHandle">搜索</el-button>
        <el-button type="primary" @click="save">保存</el-button>
        <!-- <el-button type="primary">完成下发</el-button> -->
        <el-button type="success" @click="exportOut">导出Excel</el-button>
      </div>
    <div class="title">
      <div class="left">
        <div class="rooms" v-for="(item, index) in roomList" :key="index" :class="roomIndex == index ? 'active' : ''" :title="item.roomName" @click="changeRoom(index, item.id)">
          {{ item.roomName }}
        </div>
      </div>
    </div>
    <div class="table-box">
      <!-- <div class="label">{{ projectName }}</div> -->
      <div class="box">
        <u-table ref="plTable" :data="tableData" :max-height="height" use-virtual @table-body-scroll="tableScroll" :row-height="rowHeight" border>
          <u-table-column type="index" width="100" fixed label="序号" />
          <u-table-column prop="equipmentTypeName" fixed width="120" label="类型" />
          <u-table-column prop="equipmentCode" fixed width="80" label="编码" />
          <u-table-column prop="cabinetNum" fixed width="80" label="现场柜号" />
          <u-table-column prop="localeNumber" fixed width="80" label="现场编号" />
          <u-table-column prop="equipmentAddress" width="150" label="仪表位置">
            <template slot-scope="scope">
              <el-input v-model="scope.row.equipmentAddress" placeholder="请输入内容"></el-input>
            </template>
          </u-table-column>
          <u-table-column prop="equipmentDesc" width="150" label="设备信息描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.equipmentDesc" placeholder="请输入内容"></el-input>
            </template>
          </u-table-column>
          <u-table-column prop="subentryTypeName" width="150" label="分项类型">
            <template slot-scope="scope">
              <el-select v-model="scope.row.subentryTypeId" placeholder="请选择" v-if="scope.row.equipmentTypeId == 4">
                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <p v-else>{{ scope.row.subentryTypeName }}</p>
            </template>
          </u-table-column>
          <u-table-column prop="ratedCurrent" width="150" label="额定电流(A)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ratedCurrent" placeholder="请输入内容" v-if="[1, 2, 3, 4].indexOf(scope.row.equipmentTypeId) > -1"></el-input>
              <p v-else>{{ scope.row.ratedCurrent }}</p>
            </template>
          </u-table-column>
          <u-table-column prop="ratedPower" width="150" label="变压器额定功率(kVA)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ratedPower" placeholder="请输入内容" v-if="[2].indexOf(scope.row.equipmentTypeId) > -1"></el-input>
              <p v-else>{{ scope.row.ratedPower }}</p>
            </template>
          </u-table-column>
          <u-table-column prop="ct" width="150" label="电流变比(CT)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ct" placeholder="请输入内容" v-if="[1, 2, 3, 4].indexOf(scope.row.equipmentTypeId) > -1"></el-input>
              <p v-else>{{ scope.row.ct }}</p>
            </template>
          </u-table-column>
          <u-table-column prop="pt" width="150" label="电压变比(PT)">
            <template slot-scope="scope">
              <el-input v-model="scope.row.pt" placeholder="请输入内容" v-if="[1, 2, 3, 4].indexOf(scope.row.equipmentTypeId) > -1"></el-input>
              <p v-else>{{ scope.row.pt }}</p>
            </template>
          </u-table-column>
          <u-table-column prop="useTime" width="150" label="设备投入使用时间">
            <template slot-scope="scope">
              <el-input v-model="scope.row.useTime" placeholder="请输入内容"></el-input>
            </template>
          </u-table-column>
          <u-table-column prop="equipmentModel" width="150" label="设备型号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.equipmentModel" placeholder="请输入内容"></el-input>
            </template>
          </u-table-column>
          <u-table-column prop="province" label="高/低压仪表报警配置">
            <u-table-column prop="electricity_overload" width="150" label="电流过载预警(额定电流*90%)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[0].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[0].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[0].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="electricity_superload" width="150" label="电流超载告警(>额定电流)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[1].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[1].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[1].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="electricity_data_interrupt" width="150" label="数据中断报警(min)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[2].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[2].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[2].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="electricity_threephase_voltage" width="150" label="三相电压不平衡率报警(%)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[3].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[3].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[3].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="electricity_threephase_current" width="150" label="三相电流不平衡率报警(%)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[4].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[4].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[4].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
          </u-table-column>
          <u-table-column prop="province" label="综保报警配置">
            <u-table-column prop="maintenance_data_interrupt" width="150" label="数据中断报警(A)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[5].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[5].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[5].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
          </u-table-column>
          <u-table-column prop="province" label="直流屏告警配置">
            <u-table-column prop="direct_current_input_supervoltage_one" width="150" label="一路输入交流电压超压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[6].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[6].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[6].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_input_undervoltage_one" width="150" label="一路输入交流电压欠压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[7].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[7].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[7].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_input_supervoltage_two" width="150" label="二路输入交流电压超压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[8].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[8].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[8].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_input_undervoltage_two" width="150" label="二路输入交流电压欠压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[9].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[9].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[9].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_battery_overvoltage" width="150" label="电池组过压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[10].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[10].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[10].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_battery_undervoltage" width="150" label="电池组欠压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[11].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[11].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[11].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_mother_overvoltage" width="150" label="合母电压过压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[12].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[12].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[12].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_mother_undervoltage" width="150" label="合母电压欠压报警(V)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[13].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[13].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[13].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="direct_current_off_line" width="150" label="设备离线报警(min)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[14].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[14].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[14].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
          </u-table-column>
          <u-table-column prop="province" label="变压器温控报警配置">
            <u-table-column prop="transformer_temperature_high" width="150" label="高温报警(℃)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[15].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[15].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[15].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="transformer_temperature_low" width="150" label="低温报警(℃)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[16].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[16].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[16].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="transformer_off_line" width="150" label="设备离线报警(min)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[17].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[17].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[17].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
          </u-table-column>
          <u-table-column prop="province" label="温湿度报警配置">
            <u-table-column prop="humiture_temp_high" width="150" label="高温报警(℃)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[18].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[18].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[18].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="humiture_temp_low" width="150" label="低温报警(℃)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[19].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[19].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[19].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="humiture_humi_high" width="150" label="湿度过高报警(%)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[20].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[20].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[20].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="humiture_humi_low" width="150" label="湿度过低报警(%)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[21].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[21].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[21].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
            <u-table-column prop="humiture_off_line" width="150" label="设备离线报警(min)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[22].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[22].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[22].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
          </u-table-column>
          <u-table-column prop="province" label="水浸报警配置">
            <u-table-column prop="water_sensor_off_line" width="150" label="设备离线报警(min)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[23].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[23].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[23].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
          </u-table-column>
          <u-table-column prop="province" label="视频报警配置">
            <u-table-column prop="video_off_line" width="150" label="设备离线报警(min)">
              <template slot-scope="scope">
                <el-input v-model="scope.row.attrValueList[24].equipmentAttrValue" placeholder="请输入内容" v-if="scope.row.attrValueList[24].isAvailable"></el-input>
                <p v-else>
                  {{ scope.row.attrValueList[24].equipmentAttrValue }}
                </p>
              </template>
            </u-table-column>
          </u-table-column>
        </u-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Message
} from 'element-ui';
export default {
  data() {
    return {
      id: "",
      roomList: ["配电", "配电1"],
      roomIndex: 0,
      roomId: "",
      options: [],
      value: "",
      search: "",
      projectName: "",
      loading: null,
      height: 700,
      rowHeight: 65,
      tableData: [
      ],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchRoomCabinetList();
    this.projectName = this.$getCookie("projectName");
    console.log("zhixing created");
  },
  methods: {
    searchRoomCabinetList() {
      this.$http
        .post(
          "bma-distribution-service/equipmentCabinet/searchRoomCabinetList",
          {
            projectId: this.id,
          }
        )
        .then((res) => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              this.roomList = res.data;
              this.roomIndex = 0;
              this.roomId = this.roomList[0].id;
              this.searchSubentryTypeList();
            }
          }
        });
    },
    tableScroll({ scrollTop, scrollLeft, table, judgeFlse }) {
      // {scrollTop， scrollLeft, table, judgeFlse: 这个参数返回一个boolean值，为true则代表表格滚动到了底部了，false没有滚动到底部，必须开起大数据渲染模式才能有值哦}, event
      console.log(scrollTop, scrollLeft, table, judgeFlse);
    },
    //
    searchAllEquipmentsByRoom() {
      console.log(111111111111);
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .post("bma-distribution-service/equipment/searchAllEquipmentsByRoom", {
          projectId: this.id,
          roomId: this.roomId,
          searchContent: this.search,
        })
        .then((res) => {
          if (res.data) {
            // res.data.forEach((item, index) => {
            //   item.index = index + 1;
            // });
            this.tableData = res.data;
            this.$nextTick(() => {
              this.loading.close();
            });
          }
        });
    },
    // 设备分项类型列表
    searchSubentryTypeList() {
      this.$http
        .post("bma-distribution-service/equipmentRoom/searchSubentryTypeList")
        .then((res) => {
          if (res.data) {
            res.data.unshift({ id: 0, name: "请选择" });
            this.options = res.data;
            this.searchAllEquipmentsByRoom();
          }
        });
    },
    changeRoom(index, id) {
      this.roomIndex = index;
      this.roomId = id;
      this.searchAllEquipmentsByRoom();
    },
    searchHandle() {
      this.searchAllEquipmentsByRoom();
    },
    save() {
      console.log(this.tableData);
      this.tableData.forEach((i) => {
        i.valueList = i.attrValueList;
      });

      this.$http
        .post("bma-distribution-service/equipment/editEquipmentBath", {
          dataList: this.tableData,
          dataType: 1,
        })
        .then((res) => {
          Message.success("修改成功");
        });
    },
    exportOut() {
      this.$http({
        method: "post",
        url: "bma-distribution-service/equipment/exportExcelEquipmentList",
        data: {
          projectId: this.id,
          roomIds: this.roomId,
        },
        responseType: "blob",
      }).then((res) => {
        let temp = res.headers["content-disposition"]
          .split(";")[1]
          .split("filename=")[1];
        const data = res.data;
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: "application/vnd.ms-excel",
          })
        );
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        let name = decodeURI(temp);
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
  watch: {
    search(v) {
      if (!v) {
        this.searchAllEquipmentsByRoom();
      }
    },
  },
};
</script>

<style lang="less" scoped>
 /deep/.el-table--scrollable-x .el-table__body-wrapper {
       z-index : 1;
   } 
.peizhi {
  height: 889px;
  border-radius: 7px;
  padding-top: 26px;
  box-sizing: border-box;
  border-top: 10px solid #e6e6e8;
  background: #f8f8f9;
  padding: 10px;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7e7e7;
    text-align: left;
    .left {
      display: flex;
      font-size: 16px;
      .rooms {
        color: #0e223d;
        margin-right: 50px;
        padding-bottom: 15px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 90px;
        &.active {
          font-weight: 600;
          border-bottom: 3px solid #1460e0;
        }
      }
    }
    .right {
      position: relative;
      top: -10px;
      display: flex;
      .el-input {
        margin-right: 10px;
      }
    }
  }
  .table-box {
    text-align: center;
    /deep/.el-table {
      background: #f8f8f9;
      .el-table__fixed {
        height: 680px !important;
      }
      th,
      tr {
        background-color: #f8f8f9;
      }
      th {
        > .cell {
          color: #152139;
          font-size: 14px;
          text-align: center;
        }
      }
      tr {
        td {
          font-size: 12px;
          color: #152139;
          text-align: center;
        }
      }
      .el-input {
        font-size: 12px;
      }
    }
  }
  .table-box {
    .label {
      text-align: center;
      font-size: 22px;
      font-weight: bold;
      line-height: 30px;
      color: #0e223d;
      letter-spacing: 4px;
      padding: 20px 0;
    }
    .box {
      // width: 1600px;
      height: 700px;
      // overflow-y: auto;
      // overflow-y: scroll;
    }
  }
}
</style>
